"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolve = void 0;
const uuid_1 = require("@lukeed/uuid");
function groupData(data, options) {
    const { threshold, key } = options;
    const groups = [];
    let lastRefValue = data[0][key];
    let groupIndex = 0;
    for (const datum of data) {
        if (datum[key] - lastRefValue <= threshold) {
            if (!groups[groupIndex]) {
                groups.push([datum]);
            }
            else {
                groups[groupIndex].push(datum);
            }
        }
        else {
            lastRefValue = datum[key];
            groupIndex++;
            groups.push([datum]);
        }
    }
    return groups;
}
function resolveGroupsIntersection(groups, options) {
    const { maxIteration = 3, groupMargin = 0 } = options;
    let iteration = 1;
    let hasIntersection = true;
    const newGroups = JSON.parse(JSON.stringify(groups));
    while (iteration < maxIteration && hasIntersection) {
        iteration++;
        hasIntersection = false;
        let previousGroup = newGroups[0];
        for (let i = 1; i < newGroups.length; i++) {
            const currentGroupMeta = newGroups[i].meta;
            if (previousGroup.meta.groupEndX > currentGroupMeta.groupStartX) {
                const diff = Math.abs(currentGroupMeta.groupStartX - previousGroup.meta.groupEndX);
                hasIntersection = true;
                const shift = diff + groupMargin;
                newGroups[i].meta = {
                    ...newGroups[i].meta,
                    groupStartX: currentGroupMeta.groupStartX + shift,
                    groupEndX: currentGroupMeta.groupEndX + shift,
                    groupMidX: currentGroupMeta.groupMidX + shift,
                };
            }
            previousGroup = newGroups[i];
        }
    }
    return newGroups;
}
function resolve(data, options) {
    const { width = 10, margin = 5, groupMargin = 0, key, threshold: inputThreshold, } = options;
    if (!Array.isArray(data) || data.length === 0)
        return [];
    const threshold = inputThreshold || width + margin * 2;
    const groupedData = groupData(data, { threshold, key });
    const resolvedGroups = [];
    for (const group of groupedData) {
        const groupWidth = group.length * width + (group.length - 1) * margin;
        let sum = 0;
        for (const groupDatum of group) {
            sum += groupDatum[key];
        }
        const groupMidX = sum / group.length;
        const groupStartX = groupMidX - groupWidth / 2 + width / 2;
        const groupEndX = groupWidth / 2 + groupMidX;
        resolvedGroups.push({
            group,
            meta: { groupMidX, groupStartX, groupEndX, groupWidth, id: (0, uuid_1.v4)() },
        });
    }
    return resolveGroupsIntersection(resolvedGroups, { groupMargin });
}
exports.resolve = resolve;
